import { Pipe, PipeTransform } from '@angular/core';

export type SparePartsVariant = 'initial' | 'in-transit' | 'delayed';

export function getDaysElapsed(statusChange: string | undefined): number {
  if (!statusChange) return 0;
  return Math.floor((Date.now() - new Date(statusChange).getTime()) / (1000 * 60 * 60 * 24));
}

@Pipe({
  name: 'statusNameMapping',
  standalone: true,
})
export class StatusNameMappingPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';

    const statusMapping: Record<string, string> = {
      engineer_visit: 'Engineer visit',
      appointment_booked: 'Booked',
      complete: 'Complete',
      waiting_for_parts: 'Waiting for parts',
      remedial_work_required: 'Safety issue',
      out_card_left: 'Please rebook',
      rescheduled: 'Rescheduled',
    };

    return statusMapping[value] || 'Repair in progress';
  }
}
